import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api, setQrBase } from "../api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("qora_token");
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api.me();
      setUser(data.user);
      setCompany(data.company);
    } catch {
      localStorage.removeItem("qora_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  useEffect(() => {
    api.config().then(({ data }) => setQrBase(data.qr_base)).catch(() => {});
  }, []);

  const login = async (email, password) => {
    const { data } = await api.login({ email, password });
    localStorage.setItem("qora_token", data.token);
    await refresh();
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.register(payload);
    localStorage.setItem("qora_token", data.token);
    await refresh();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("qora_token");
    setUser(null);
    setCompany(null);
  };

  return (
    <AuthContext.Provider value={{ user, company, loading, login, register, logout, refresh, setCompany }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
